import { useEffect } from 'react';
import { App, URLOpenListenerEvent } from '@capacitor/app';

export const AppUrlListener: React.FC<any> = () => {
    useEffect(() => {
        App.addListener('appUrlOpen', ({ url }: URLOpenListenerEvent) => {
            const { search, hash } = new URL(url);
            if (search || hash) {
                const href = `${window.location.pathname}${search}${hash}`;
                console.log(`Deep linked to "${href}"`);
                window.location.href = href;
            }
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};
